import { useState, useEffect, useRef } from 'react';
import { TooltipContainer } from './Tooltip.styles';
import { PropsWithChildren } from 'react';

type TooltipProps = {
  label?: string;
  wordwrap?: boolean;
  // ref to be used for conditional rendering based on ellipsis
  ellipsisRef?: React.RefObject<HTMLElement>;
} & PropsWithChildren;

const Tooltip: React.FC<TooltipProps> = ({
  children,
  label,
  wordwrap = true,
  ellipsisRef
}) => {
  const ref = useRef(null);
  const [hasEllipsis, setHasEllipsis] = useState(false);
  useEffect(() => {
    if (ellipsisRef?.current) {
      setHasEllipsis(ellipsisRef.current.scrollHeight > ellipsisRef.current.clientHeight);
    }
  }, [ellipsisRef]);

  if (!ellipsisRef || ellipsisRef?.current && hasEllipsis) {
    return (
      <TooltipContainer
        label={label}
        position="top"
        multiline={wordwrap}
        className={wordwrap ? 'wordwrap' : ''}
        ref={ref}
        zIndex={2000}
      >
        {children}
      </TooltipContainer>
    );
  } else {
    return children;
  }


};

export default Tooltip;
